var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/ViewPortMain/index.js";
import React from 'react';
import pt from 'prop-types';
import Wrapper from './Wrapper';

const ViewPortMain = ({
  height,
  children
}) => /*#__PURE__*/React.createElement(Wrapper, {
  height: height,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 10,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  width: "100%",
  height: "100%",
  stroke: "black",
  strokeWidth: "1",
  fill: "white",
  shapeRendering: "geometricPrecision",
  style: {
    overflow: 'visible'
  },
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }
}, children));

ViewPortMain.propTypes = {
  height: pt.number.isRequired,
  children: pt.node.isRequired
};
export default ViewPortMain;
